import { render, staticRenderFns } from "./albumInfo2.vue?vue&type=template&id=4822fd34&scoped=true&"
import script from "./albumInfo2.vue?vue&type=script&lang=ts&"
export * from "./albumInfo2.vue?vue&type=script&lang=ts&"
import style0 from "./albumInfo2.vue?vue&type=style&index=0&id=4822fd34&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4822fd34",
  null
  
)

export default component.exports